import { render, staticRenderFns } from "./AsanaTodoList.vue?vue&type=template&id=4775059e&"
import script from "./AsanaTodoList.vue?vue&type=script&lang=js&"
export * from "./AsanaTodoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports